import Image from '@/components/common/Image'
import classnames from 'classnames/bind'

// Styles
import styles from './style.module.scss'

const cx = classnames.bind(styles)

type FeatureItemType = {
  title: string
  iconUrl: string
  description: string
}

const featureItems: FeatureItemType[] = [
  {
    title: 'Exclusive Membership',
    iconUrl: '/images/livemallclub/why-item-logo-1@3x.png',
    description: 'Access to a curated shopping environment through invitation only.',
  },
  {
    title: 'Real-time Interactive Live Streams',
    iconUrl: '/images/livemallclub/why-item-logo-4@3x.png',
    description: 'Direct, face-to-face engagement with sellers and KOLs',
  },
  {
    title: 'Immersive Shopping Experiences',
    iconUrl: '/images/livemallclub/why-item-logo-2@3x.png',
    description: 'Zero-distance interaction for detailed product understanding.',
  },
  {
    title: 'Personalized Suggestions',
    iconUrl: '/images/livemallclub/why-item-logo-3@3x.png',
    description: 'Discover items picked just for you based on your preferences.',
  },
]

const FeatureList = () => {
  return (
    <div className={cx('feature-list')}>
      <div className={cx('feature-list-content')}>
        {featureItems.map((item, index) => (
          <div key={index} className={cx('feature-list-item')}>
            <div className={cx('feature-list-item-left')}>
              <div className={cx('feature-list-item-image')}>
                <div className={cx('feature-list-item-image-wrapper')}>
                  <Image src={item.iconUrl} fill alt={''} />
                </div>
              </div>
            </div>
            <div className={cx('feature-list-item-right')}>
              <div className={cx('feature-list-item-title')}>{item.title}</div>
              <div className={cx('feature-list-item-description')}>{item.description}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default FeatureList
